<div
    class="group/toast-item pn-toast"
    role="alert"
    @showState
    [attr.data-toast-id]="toast().id"
    [ngClass]="[toast().type]"
    (mouseenter)="handleMouseEnter()"
    (mouseleave)="handleMouseLeave()"
>
    @switch (toast().type) {
        @case ('success') {
            <svg-icon src="assets/icons/check-in.svg" svgClass="size-4" class="mt-[2px]" />
        }
        @case ('info') {
            <svg-icon
                src="assets/icons/information-circle.svg"
                svgClass="size-4"
                class="mt-[2px] icon:fill-[#2563eb]"
            />
        }
        @case ('warning') {
            <svg-icon src="assets/icons/exclamation.svg" svgClass="size-4" class="mt-px" />
        }
        @case ('error') {
            <svg-icon src="assets/icons/error.svg" svgClass="size-4" class="mt-[2px]" />
        }
        @default {}
    }
    <div class="pn-toast__content">
        @if (toast().title) {
            <div class="pn-toast__title">{{ toast().title }}</div>
        }
        <div class="pn-toast__message" [innerHTML]="toast().message"></div>
        @if (toast().action; as action) {
            <div class="mt-2 flex">
                <button
                    pnButton
                    size="tiny"
                    class="px-4 font-lato-bold font-bold"
                    (click)="handleAction()"
                >
                    {{ action.label }}
                </button>
            </div>
        }
    </div>

    <button
        pnButton
        icon
        size="tiny"
        class="pn-toast__close group-hover/toast-item:!visible"
        (click)="handleClear()"
    >
        <svg-icon src="assets/icons/close.svg" class="icon:fill-neutral-07" svgClass="size-4" />
    </button>
</div>
